/* global FileReader, DataTransfer */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'preview', 'inputWrapper']
  static values = {
    modelName: { type: String, default: 'product' },
    attributeName: { type: String, default: 'photos_attributes' },
    maxPhotos: { type: Number, default: 6 },
    fieldName: { type: String, default: '' }
  }

  connect () {
    this.inputTarget.addEventListener('change', this.handleFilesSelected.bind(this))
    this.previewElements = []
    this.updateInputVisibility()
  }

  handleFilesSelected () {
    const files = Array.from(this.inputTarget.files)
    const currentCount = this.getVisiblePhotosCount()
    const remainingSlots = this.maxPhotosValue - currentCount

    files.slice(0, remainingSlots).forEach((file) => {
      if (!file.type.startsWith('image/')) return
      this.addPhotoPreview(file)
    })

    this.inputTarget.value = ''
  }

  getVisiblePhotosCount () {
    return this.previewTarget.querySelectorAll('.nested-form-wrapper:not([style*="display: none"])').length
  }

  updateInputVisibility () {
    const wrapper = this.hasInputWrapperTarget ? this.inputWrapperTarget : this.inputTarget.closest('.form__group')
    if (!wrapper) return

    if (this.getVisiblePhotosCount() >= this.maxPhotosValue) {
      wrapper.style.display = 'none'
    } else {
      wrapper.style.display = ''
    }
  }

  addPhotoPreview (file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      const index = `${Date.now()}${Math.floor(Math.random() * 10000)}`

      const div = document.createElement('div')
      div.className = 'nested-form-wrapper relative group'
      div.dataset.newPreview = 'true'

      const fileInput = document.createElement('input')
      fileInput.type = 'file'
      fileInput.name = this.fieldNameValue
        ? this.fieldNameValue
        : `${this.modelNameValue}[${this.attributeNameValue}][${index}][image]`
      fileInput.style.display = 'none'

      const dt = new DataTransfer()
      dt.items.add(file)
      fileInput.files = dt.files

      const positionHtml = this.fieldNameValue
        ? ''
        : `<input type="hidden" name="${this.modelNameValue}[${this.attributeNameValue}][${index}][position_score]" value="${index + 1}" />`

      div.innerHTML = `
        ${positionHtml}
        <img src="${e.target.result}" class="w-full h-32 object-cover rounded-lg border" alt="Preview" />
        <div class="absolute top-2 left-2 bg-green-500 bg-opacity-80 text-white text-xs px-2 py-1 rounded">
          Новое
        </div>
        <button type="button"
                class="absolute bottom-2 right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-600 cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity"
                data-action="image-preview#removePreview">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      `
      div.insertBefore(fileInput, div.firstChild)

      this.previewTarget.appendChild(div)
      this.previewElements.push(div)
      this.updateInputVisibility()
    }
    reader.readAsDataURL(file)
  }

  removePreview (event) {
    const wrapper = event.currentTarget.closest('.nested-form-wrapper')
    if (wrapper) {
      const index = this.previewElements.indexOf(wrapper)
      if (index > -1) {
        this.previewElements.splice(index, 1)
      }
      wrapper.remove()
      this.updateInputVisibility()
    }
  }

  onPhotoRemoved () {
    setTimeout(() => this.updateInputVisibility(), 10)
  }
}
